import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Batch } from '../models/batch';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BatchQuery } from '../models/batch-query';
import { combineLatest, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { map, startWith, switchMap, tap } from 'rxjs/operators';
import { EntityEnum } from '../enum/entity.enum';

@Injectable({ providedIn: 'root' })
export class BatchService extends EntityCollectionServiceBase<Batch> {

    private loaded = false;

    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, private http: HttpClient) {
        super(EntityEnum.BATCH, serviceElementsFactory);
    }

    all(): Observable<Batch[]> {
        if (this.loaded) {
            return this.entities$;
        }
        return this.query({ pageNumber: 1, itemsPerPage: 100, sortColumn: 'date', sortDescending: true }).pipe(
            map((result) => result['hydra:member']),
            tap(() => this.loaded = true)
        );
    }

    get(id: string): Observable<Batch> {
        return this.entityMap$.pipe(
            map((entities) => entities[id]),
            switchMap((value) => value ? of(value) : this.getByKey(id))
        );
    }

    getMultiple(ids: string[]): Observable<Batch[]> {
        return combineLatest(ids.map(id => this.get(id)));
    }

    query(query: BatchQuery): Observable<Batch[]> {
        let params = new HttpParams()
            .set('counters', 'ALL')
            .set('page', query.pageNumber.toString())
            .set('itemsPerPage', query.itemsPerPage.toString());
        if (query.sortColumn) {
            params = params.set('order[' + query.sortColumn + ']', query.sortDescending ? 'DESC' : 'ASC');
        }
        if (query.name) {
            params = params.set('name', query.name);
        }
        const headers = new HttpHeaders({ Accept: 'application/ld+json' });
        return this.http.get<any>(`${environment.apiUrl}/batch`, { headers, params }).pipe(
            tap((result) => this.addManyToCache(result['hydra:member']))
        );
    }

}
